import React from 'react';
import '../styles/Footer.css';

const Footer: React.FC = () => {
    return (
        <footer className="site-footer">
            <p>© Antonino NICOLETTI - UP Cité</p>
            <p className="dev-credit">Développé par Elio Darras</p>
            <p className="footer-rgpd">
                <a href="/privacy-notice">Privacy notice (EN)</a>
                <span aria-hidden="true"> | </span>
                <a href="/donnees-personnelles">Mentions d'information (FR)</a>
            </p>
        </footer>
    );
};

export default Footer;